import React, { useState, useEffect } from "react";
import useToken from "shared/hook/useToken";
import baseUrl from "config/baseUrl";
import { removeStoredAuthToken } from "shared/utils/authToken";

const axios = require("axios").default;

const useCurrentUser = () => {
  const { token } = useToken();
  const [curruntUser, setCurruntUser] = useState(null);

  const getUserDetail = (curruntUser) => {
    axios
    .get(`${baseUrl}/v1/user/user?userId=${curruntUser.user.userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      const user = {...curruntUser};
      user.detail = response.data;
      getUsersPermissionList(user);
      setCurruntUser(user);
    });
  }

  const getUsersPermissionList = (curruntUser) => {
    var data = JSON.stringify({
      params: {
        userId: curruntUser.user.userId
      },
      show: 1000,
      page:1,
      orderBy: "indicatorsDatasetSettingId",
      orderType: "ASC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/user/usersPermissionList`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
    .then((response) => {
      const user = {...curruntUser};
      user.permission = response.data.data;
      setCurruntUser(user);
    })
    .catch((error) => {
      console.log(error);
    });
  }

  useEffect(() => {
    if (token) {
      var config = {
        method: "get",
        url: `${baseUrl}/v1/auth/currunt-user`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      axios(config)
        .then((response) => {
          getUserDetail(response.data);
          // getUsersPermissionList(response.data);
        })
        .catch((error) => {
          console.log(error);
          removeStoredAuthToken();
          window.location = "/";
        });
    }
  }, []);
  
  return {
    curruntUser,
  };
};

export default useCurrentUser;
